//Imports
import './Styles/Rodape.style.css';
import handleLinkClick from '../Components/ScrollTo';

//Assets
import VecLogo from '../Assets/V&C---Branco 1.png';
import { BsTelephoneFill } from 'react-icons/bs';
import { BsWhatsapp } from 'react-icons/bs';
import { AiOutlineMail } from 'react-icons/ai';

const Rodape = () => {
    return (
        <section id="rodape">
            <div className='vec-box'>
                <div className='img-box-rodape'>
                    <img src={VecLogo} alt='Logo V&C' />
                </div>
                <div className='dados-vec-rodape'>
                    <div tabIndex={65} aria-label='Informações para contato'>
                        <p tabIndex={66}> <BsWhatsapp /> (54) 8164-4156 </p>
                        <p tabIndex={67}> <BsTelephoneFill /> (28) 99988-0837 </p>
                    </div>
                    <p tabIndex={68}> <AiOutlineMail /> contato@vecedutec.com.br </p>
                </div>
            </div>
            <div className='vec-rodape'>
                <h4 tabIndex={69}>Cursos</h4>
                <a tabIndex={70} href='#CoursesAndSolutions' onClick={handleLinkClick}>Cursos de Prateleira</a>
                <a tabIndex={71} href='#CoursesAndSolutions' onClick={handleLinkClick}>Plataforma LMS V&C</a>
                <a tabIndex={72} href='#CoursesAndSolutions' onClick={handleLinkClick}>Ferramentas de Autoria</a>
                <a tabIndex={73} href='#CoursesAndSolutions' onClick={handleLinkClick}>Fábrica de Conteúdo</a>
                <a tabIndex={74} href='#CoursesAndSolutions' onClick={handleLinkClick}>Consultoria Pedagógica</a>
                <a tabIndex={75} href='#CoursesAndSolutions' onClick={handleLinkClick}>Revisão Textual</a>
                <a tabIndex={76} href='#CoursesAndSolutions' onClick={handleLinkClick}>Tradução e interpretação em LIBRAS</a>
                <a tabIndex={77} href='#CoursesAndSolutions' onClick={handleLinkClick}>EAD (E-Learning)</a>
            </div>
            <div className='vec-rodape'>
                <h4 tabIndex={78}>A V&C</h4>
                <a tabIndex={79} href='#about' onClick={handleLinkClick}>Quem Somos</a>
                <a tabIndex={80} href='#about' onClick={handleLinkClick}>Missão</a>
                <a tabIndex={81} href='#about' onClick={handleLinkClick}>Visão</a>
                <a tabIndex={82} href='#about' onClick={handleLinkClick}>Valores</a>
            </div>
        </section>
    )
}

export default Rodape;